export const DeleteOperationRowPopup = ({
  operationIndex,
  operationsEmployees,
  setOperationsEmployees,
}) => {
  return (
    <div
      className="modal fade"
      id="staticOperationDeleteRow"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content modal-content-active-popup">
          <div className="modal-header modal-header-active-popup"></div>
          <div className="modal-body modal-body-active-popup  popup-text">
            Are you sure you want to delete a row?
          </div>
          <div className="modal-footer modal-footer-active-popup">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={() =>
                setOperationsEmployees(
                  operationsEmployees?.filter(
                    (item, i) => i !== operationIndex
                  )
                )
              }
              style={{ width: "90px" }}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-primary btn-logout-no"
              data-bs-dismiss="modal"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
